import { apiGet } from '../services/apiClient';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '';
const AUTH_TIMEOUT_MS = 6000;

const fetchWithTimeout = async (url, options = {}, timeoutMs = AUTH_TIMEOUT_MS) => {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), timeoutMs);
  try {
    return await fetch(url, { ...options, signal: controller.signal });
  } finally {
    clearTimeout(timeout);
  }
};

const readJson = async (res) => {
  const text = await res.text();
  if (!text) return {};
  try {
    return JSON.parse(text);
  } catch {
    return { message: text };
  }
};

export const loginAdmin = async (email, password, twoFactorToken) => {
  const res = await fetchWithTimeout(`${API_BASE}/api/admin/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({
      email,
      password,
      ...(twoFactorToken ? { twoFactorToken } : {}),
    }),
  });
  const data = await readJson(res);
  if (!res.ok) throw new Error(data?.message || 'Login failed');
  const accessToken = data.accessToken || data.token;
  return { ...data, accessToken };
};

export const refreshToken = async () => {
  const res = await fetchWithTimeout(`${API_BASE}/api/admin/auth/refresh`, {
    method: 'POST',
    credentials: 'include',
  });
  const data = await readJson(res);
  if (!res.ok) throw new Error(data?.message || 'Token refresh failed');
  const accessToken = data.accessToken || data.token || '';
  return { ...data, accessToken };
};

export const fetchProfile = async (accessToken) => {
  const res = await fetchWithTimeout(`${API_BASE}/api/admin/auth/me`, {
    headers: { Authorization: `Bearer ${accessToken}` },
    credentials: 'include',
  });
  const data = await readJson(res);
  if (!res.ok) throw new Error(data?.message || 'Profile fetch failed');
  return data;
};

export const logoutAdmin = async (accessToken) => {
  await fetchWithTimeout(`${API_BASE}/api/admin/auth/logout`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${accessToken}` },
    credentials: 'include',
  });
};

export const changeAdminPassword = async (accessToken, currentPassword, newPassword) => {
  const res = await fetchWithTimeout(`${API_BASE}/api/admin/auth/change-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    credentials: 'include',
    body: JSON.stringify({ currentPassword, newPassword }),
  });
  const data = await readJson(res);
  if (!res.ok) throw new Error(data?.message || 'Password change failed');
  return data;
};

export const verifyAdminTwoFactor = async (tempToken, token) => {
  const res = await fetchWithTimeout(`${API_BASE}/api/admin/2fa/verify-login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ tempToken, token }),
  });
  const data = await readJson(res);
  if (!res.ok) throw new Error(data?.message || 'Two-factor verification failed');
  const accessToken = data.accessToken || data.token;
  return { ...data, accessToken };
};

export const fetchAdminSummary = async (accessToken) => {
  return apiGet('/api/admin/summary', accessToken);
};


